import { useEffect, useState } from "react";
import { getAPI } from "../API/ApiService";

const useDuplicateTitleCheck = ({ url, payload }) => {
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    const checkDuplicateTitle = async () => {
      // Don't run if payload is missing or title is empty
      if (!payload || !payload.title?.trim()) {
        setIsDuplicate(false);
        return;
      }

      setChecking(true);
      try {
        const params = new URLSearchParams(payload);
        const call = `${url}?${params.toString()}`;
        const res = await getAPI(call);

        if (res?.status === 200 && Array.isArray(res.data)) {
          setIsDuplicate(res.data.length > 0);
        } else {
          setIsDuplicate(false);
        }
      } catch (err) {
        console.error("API check failed", err);
        setIsDuplicate(false);
      } finally {
        setChecking(false);
      }
    };

    checkDuplicateTitle();
  }, [JSON.stringify(payload)]); // dependency updated to watch payload changes

  return { isDuplicate, checking };
};

export default useDuplicateTitleCheck;
